import { z } from 'zod';
import { accountBadgeDistributionStatusSchema, accountBadgeStatusSchema } from '../entities/AccountBadgeEntityTypes';
import { accountBadgeAccountRequestSchema } from '../schema/commonRequestSchema';
import { accountBadgeResponseSchema } from '../schema/commonResponseSchema';
export const createOrUpdateAccountBadgeMigrationRequestSchema = z.object({
    badgeId: z.string().uuid(),
    accountBadgeId: z.string().uuid().optional(),
    accountBadgeNumber: z.string().min(15).max(25),
    account: accountBadgeAccountRequestSchema,
    status: accountBadgeStatusSchema,
    /**
     * if status is revoked need to fill this
     */
    statusReason: z
        .object({
        title: z.string(),
        description: z.string().optional(),
        canReissue: z.boolean().optional(),
    })
        .optional(),
    statusLastUpdatedAt: z.number().optional(),
    distributionStatusLastUpdatedAt: z.number().optional(),
    distributionStatus: accountBadgeDistributionStatusSchema,
    printStatus: z.enum(['success']).optional(),
    issuedAt: z.number(),
    expiresAt: z.number(),
});
export const createOrUpdateAccountBadgeMigrationResponseSchema = z.object({
    accountBadge: accountBadgeResponseSchema,
});
export const createOrUpdateAccountBadgeMigrationFunctionDef = {
    name: 'createOrUpdateAccountBadgeMigration',
    requestSchema: createOrUpdateAccountBadgeMigrationRequestSchema,
    responseSchema: createOrUpdateAccountBadgeMigrationResponseSchema,
};
